import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Mails`

export function insertarMail(mail) {
  return http.post(API_ENDPOINT, mail)
}
